import React from "react";
import GroupHeader from "../GroupHeader/GroupHeader";

export default function GroupHeaderSection({
  setShowProfileView,
  groupActiveChat,
  setActiveSection,
}) {
  return (
    <>
      <header className="w-full min-h-[45px] py-2.5 bg-white dark:bg-slate-900 flex items-center justify-between border-b border-[#EBEBEB] dark:border-slate-700 text-black dark:text-white p-4 text-center">
        <GroupHeader
          setShowProfileView={setShowProfileView}
          groupActiveChat={groupActiveChat}
          setActiveSection={setActiveSection}
        />
      </header>
    </>
  );
}
